export default {
  operateSettlement: {
    reportTitle: '经营报表',
    reportDescription: '按时间范围和统计维度查看经营收入与预存金数据。',
    summaryTitle: '经营数据汇总',
    metric: { share: '占比' },
    prepaidSummary: '预存金汇总',
    prepaidPrincipalReceived: '实收本金',
    prepaidPrincipalRefund: '本金退款',
    prepaidGiftReceived: '实收赠金',
    prepaidGiftRefund: '赠金退款',
    dimensionSummary: '分维度统计',
    filterDateRange: '统计日期',
    filterStoreGroup: '门店区域',
    filterProductKeyword: '商品名称',
    groupAll: '全部区域',
    groupEast: '华东区域',
    groupSouth: '华南区域',
    groupNorth: '华北区域',
    dimensionStore: '按门店',
    dimensionProduct: '按商品',
    dimensionProductType: '按商品类型',
    dimensionBackendCategory: '按后台分类',
    dimensionFrontCategory: '按前台分类',
    dimensionSalesChannel: '按售卖渠道',
    dimensionPayChannel: '按支付渠道',
    metricActualNet: '实际净收',
    metricReceived: '实收金额',
    metricRefund: '退款金额',
    metricPrepaidSpent: '预存金消费',
    metricPrepaidRefund: '预存金退款',
    metricPrepaidNet: '预存金净消费',
    metricNetSales: '净销售额',
    metricShare: '净销售额占比',
    metricPrepaidShare: '预存金净消费占比',
    help: {
      summaryActualNet:
        '实际资金净收 = 实际资金收款 - 实际资金退款，允许为负数。预存金消费及预存金余额退款不计入实际资金收付；已确认冲正计入冲正发生日，不回写历史。',
      summaryReceived: '业务系统确认整笔支付成功后，将订单实际资金收款计入营业日；预存金消费及未成功订单不计入。跨日分笔支付按支付成功日统计。',
      summaryRefund: '按退款成功营业日统计退回的实际资金，不含预存金余额退款；尚未成功的退款不计入，不回写历史结果。',
      summaryPrepaidSpent: '整单成功营业日使用的预存金本金与赠金，不是充值收款。',
      summaryPrepaidRefund: '退款成功营业日退回的预存金本金与赠金，不是实际资金流出。',
      summaryPrepaidNet: '预存金净消费 = 预存金消费金额 - 预存金退款金额，可为负数。',
      dimension: {
        store: '按销售归属门店汇总，展示门店名称。',
        product: '按销售商品汇总。',
        productType: '按商品类型汇总。',
        backendCategory: '按商品所属后台分类汇总。',
        frontCategory: '按商品所属前台分类汇总。',
        salesChannel: '按订单销售渠道汇总。',
        payChannel: '按订单支付渠道汇总。',
      },
      tableStoreGroup: '按门店统计时展示门店所属的门店组；其他统计维度不按门店组拆分，此列显示“-”。',
      tableOrderCount: '所选营业日范围内，完成收款的销售订单按订单主键计数。同一订单多笔支付只计一单，后续退款不冲减订单数。',
      tableSalesQuantity: '所选筛选范围内按当前统计维度汇总的商品销售数量。',
      tableReceived:
        '所选营业日范围内，整单成功订单的实际资金收款，不含预存金消费；按当前维度汇总，退款单独列示。组合支付按支付明细归集，不重复计入整单金额。',
      tableRefund: '按退款成功营业日统计退回的实际资金，不含预存金余额退款；尚未成功的退款不计入，不回写历史结果。',
      tableActualNet: '实际资金净收 = 实际资金收款 - 实际资金退款，与顶部卡片同口径；不含预存金消费及余额退款，允许为负数。',
      tableNetSales: '净销售额 = 实际资金收款 + 预存金消费 - 实际资金退款 - 预存金退款。',
      tablePrepaidSpent: '整单成功营业日使用的预存金本金与赠金，不是充值收款。',
      tablePrepaidRefund: '退款成功营业日退回的预存金本金与赠金，不是实际资金流出。',
      tablePrepaidNet: '预存金净消费 = 预存金消费金额 - 预存金退款金额，可为负数。',
      tableRefundOrderCount: '所选期间发生成功退款的原订单主键数，同一订单跨多日退款也仅计一次。',
      tableShare: '本行净销售额 ÷ 当前筛选结果的净销售额合计 × 100%。分母包含全部筛选结果，不仅是当前页；分母为 0 时显示 0%。',
      tablePrepaidShare: '本行预存金净消费 ÷ 当前筛选结果的净销售额合计 × 100%。分母为 0 时显示 0%。',
    },
    columnStore: '门店名称',
    columnProduct: '商品名称',
    columnProductType: '商品类型',
    columnBackendCategory: '后台分类',
    columnFrontCategory: '前台分类',
    columnSalesChannel: '售卖渠道',
    columnPayChannel: '支付渠道',
    columnStoreGroup: '门店区域',
    columnOrderCount: '订单数',
    columnSalesQuantity: '销售数量',
    columnRefundOrderCount: '退款订单数',
    mockStoreA: '华东一店',
    mockStoreB: '华东二店',
    mockStoreC: '华东三店',
    mockStoreD: '华南一店',
    mockStoreE: '华南二店',
    mockStoreF: '华南三店',
    mockStoreG: '华北一店',
    mockStoreH: '华北二店',
    mockProductTicket: '单次游玩票',
    mockProductPackage: '亲子畅玩套票',
    mockProductGame: '互动游戏体验',
    mockProductGift: '主题纪念礼品',
    mockTypeTicket: '门票',
    mockTypePackage: '套票',
    mockTypeGame: '互动体验',
    mockTypeGoods: '零售商品',
    mockBackendTicket: '门票类',
    mockBackendGame: '游乐项目',
    mockBackendGoods: '商品零售',
    mockFrontPopular: '热门推荐',
    mockFrontFamily: '亲子游玩',
    mockFrontGift: '礼品周边',
    mockChannelCounter: '门店收银',
    mockChannelMiniProgram: '微信小程序',
    mockChannelSelfService: '自助设备',
    mockPayCash: '现金',
    mockPayWechat: '微信支付',
    mockPayAlipay: '支付宝',
    detail: {
      title: '门店日结详情',
      shopCode: '门店编码',
      businessDate: '营业日期',
      snapshot: '正式快照',
      realtime: '实时口径',
      paymentStopped: '已停止收款',
      paymentOpen: '收款开放',
      close: '关闭',
      retry: '重试',
      loading: '正在加载数据…',
      mainFailed: '日结详情加载失败，请重试。',
      mainEmpty: '暂无日结详情。',
      empty: '暂无明细。',
      scopeHint: '统计范围：桌面收银机、微信小程序。整单支付成功后统计金额与订单；部分收款和无成功结果不计入。',
      intervalHint: '营业日区间：{start}（含）→ {end}（不含）；本次统计截至 {cutoff}（不含），不等同于日结操作时间。',
      queryTime: '查询时间',
      attention: '需关注',
      noAttention: '无关注事项',
      snapshotHint: '待处理退款不扣减净收；日结后退款与冲正不改写已保存快照。',
      fundsTitle: '实际资金汇总',
      actualPaymentAmount: '实际资金收款',
      actualRefundAmount: '实际资金退款',
      actualNetAmount: '实际资金净收',
      result: '日结结果',
      orders: '订单概览',
      channels: '售卖渠道汇总',
      payments: '支付渠道汇总',
      refunds: '退款处理概览',
      channelsHint: '展示完整渠道明细及合计。整单成功订单只计一次，不按支付明细重复计算。',
      paymentsHint: '实际资金独立小计，预存金本金与赠金合并小计；预存金不计入实际资金，不计算跨资金类别合计。',
      prepaid: '预存金',
      principal: '本金',
      gift: '赠金',
      refundHint: '截至 {time}，汇总尚未结束的售后，不区分处理阶段。',
      settledRefundHint: '日结时待退款金额：{amount} · {time}',
      currentRefundHint: '退款关注事项按实时口径：当前待退款 {count} 笔 / {amount}（查询时点 {time}），不是统计截止时数据。',
      currentRefund: '当前待处理退款',
      cutoffRefund: '截止时待处理退款',
      settledRefund: '日结时待处理退款',
      refundCount: '待处理退款订单数',
      refundAmount: '待退款金额',
      cashSummary: '现金核对汇总',
      cashSummaryFailed: '主详情加载失败，现金摘要未知；下方设备核对独立加载，不代表门店汇总。',
      cashSummaryLoading: '现金摘要正在加载；下方设备核对独立加载。',
      cashSummaryUnknown: '暂无现金摘要，未知金额显示“—”；下方设备核对独立加载。',
      cashHint: '应交现金 = 期初现金 + 现金收款 + 现金调入 - 现金退款 - 现金调出 - 抽大钞 - 其他现金支出。',
      cashScopeHint:
        '期初现金：第一个现金期间取开班备用金，后续现金期间取上一日切实点；现金收支从当前营业日日切时间起算，不从盘点完成时间起算。仅核对收银机现金，小程序不参与交班和盘点。各设备长短款不抵销异常，实点未留存显示“—”。逐台差异见下表，不在门店汇总显示净差额。',
      cashDifference: '现金差异',
      cashDifferenceHint: '长款 {over} / 短款 {short}',
      devices: '现金核对',
      devicesFailed: '设备现金核对加载失败，请重试。',
      devicesEmpty: '暂无设备现金核对记录。',
      shifts: '班次与人员',
      shiftsFailed: '班次与人员加载失败，请重试。',
      shiftsEmpty: '暂无班次记录。',
      history: '日结记录',
      historyFailed: '日结历史加载失败，请重试。',
      historyEmpty: '暂无日结历史记录。',
      events: '现金收支类型',
      eventsFailed: '本班次现金事件加载失败，请重试。',
      eventsEmpty: '本班次暂无现金事件。',
      eventsHint: '按当前班次查询现金事件。“其他现金支出”仅展示汇总，接口未提供对应支出事件。',
      expand: '展开明细',
      collapse: '收起明细',
      details: '班次明细',
      shiftCash: '营业日现金分项',
      shiftTimeHint: '现金统计时间：{start}（含）→ {end}（不含）',
      subtotal: '小计',
      total: '合计',
      settlementStatus: '日结状态',
      settlementNo: '日结编号',
      settlementUserName: '日结人',
      createTime: '日结时间',
      settlementMethod: '日结方式',
      remark: '日结备注',
      dayStartTime: '营业日开始时间（含）',
      dayEndTime: '营业日结束时间（不含）',
      statsCutoffTime: '统计截至时间',
      settingVersionNo: '配置版本号',
      id: '日结记录 ID',
      shopId: '门店 ID',
      createBy: '创建人',
      revokeUserId: '撤销人 ID',
      revokeUserName: '撤销人',
      revokeTime: '撤销时间',
      revokeReason: '撤销原因',
      paymentOrderCount: '支付完成订单数',
      refundOrderCount: '退款订单数',
      validOrderCount: '有效订单数',
      refundApplyOrderCount: '申请退款订单数',
      orderPaymentAmount: '订单支付金额',
      orderRefundAmount: '订单退款金额',
      orderNetAmount: '订单净支付金额',
      channelType: '售卖渠道',
      deviceName: '设备名称',
      deviceIdentity: '设备名称 / 设备编码',
      shiftIdentity: '班次名称 / 班次编号',
      deviceCode: '设备编码',
      fundCategory: '资金类别',
      payType: '支付渠道',
      paymentAmount: '收款 / 消费金额',
      paymentRefundAmount: '退款金额',
      netAmount: '净收 / 净消费金额',
      cashExpectedAmount: '应交现金',
      cashActualAmount: '实点现金',
      cashOverAmount: '现金长款',
      cashShortAmount: '现金短款',
      requiredDeviceCount: '需盘点设备数',
      checkedDeviceCount: '已盘点设备数',
      uncheckedDeviceCount: '未盘点设备数',
      cashDiffDeviceCount: '差异设备数',
      cashCheckStatus: '核对状态',
      checkShiftNo: '班次',
      checkTime: '盘点时间',
      startTime: '统计开始时间（含）',
      endTime: '统计结束时间（不含）',
      openingCashAmount: '期初现金',
      expectedCashAmount: '应交现金',
      actualCashAmount: '实点现金',
      cashDiffAmount: '现金差异',
      cashCollectionAmount: '现金收款',
      cashRefundAmount: '现金退款',
      cashInAmount: '现金调入',
      cashOutAmount: '现金调出',
      cashDropAmount: '抽大钞',
      otherCashExpenseAmount: '其他现金支出',
      openingSource: '期初来源（原始值）',
      openingSourceId: '期初来源 ID',
      shiftNo: '班次编号',
      shiftName: '班次名称',
      shiftList: '班次列表',
      viewMore: '查看更多',
      participants: '参与员工',
      handoverNo: '交班编号',
      closeUserName: '交班员工',
      closeTime: '交班时间',
      handoverStatus: '交班状态',
      sliceStartTime: '班次切片开始（含）',
      sliceEndTime: '班次切片结束（不含）',
      orderCount: '班次订单数',
      shiftCount: '班次数',
      eventTime: '事件时间',
      eventType: '现金收支类型',
      amount: '事件金额',
      operatorName: '操作人',
      reason: '原因',
      orderNo: '订单号',
      businessNo: '业务号',
      enums: {
        status: { PENDING: '待日结', SETTLED: '已日结', REVOKED: '已撤销' },
        method: { MANUAL: '手动日结', AUTOMATIC: '自动日结' },
        channel: { 3: '桌面收银机', 4: '微信小程序' },
        fund: { ACTUAL_FUNDS: '实际资金', PREPAID_PRINCIPAL: '预存金本金', PREPAID_GIFT: '预存金赠金' },
        pay: {
          WECHAT: '微信支付',
          ALIPAY: '支付宝',
          QQPAY: 'QQ 钱包',
          UNINPAY: 'UNINPAY',
          BESTPAY: '翼支付',
          JDPAY: '京东支付',
          DIGICCY: '数字人民币',
          CASH: '现金',
        },
        cash: { UNCHECKED: '部分收银机未盘点', BALANCED: '无差异', DIFFERENCE: '现金有差异', DIFFERENCE_UNCHECKED: '现金有差异，部分收银机未盘点' },
        attention: { CASH_DIFFERENCE: '现金核对存在差异', PENDING_REFUND: '存在待处理退款' },
        handover: { OPEN: '未交班', CLOSED: '已交班' },
        event: {
          COLLECTION: '收款',
          REFUND: '退款',
          CASH_IN: '调入',
          CASH_OUT: '调出',
          CASH_DROP: '投库',
          OPEN_DRAWER: '开钱箱',
        },
      },
    },
    board: {
      loading: '正在加载日结数据',
      loadFailed: '日结数据加载失败，请重试。',
      retry: '重试',
      refresh: '刷新',
      shopCode: '门店编码',
      shopFilter: '门店',
      filterLimit: '门店名称、门店编码各最多输入 100 个字符，门店最多选择 100 个。',
      dataTime: '查询时间',
      statsCutoffTime: '统计截止时间',
      actualNetAmount: '实际净收',
      settlementNo: '日结单号',
      settlementMethod: '日结方式',
      settlementUserName: '日结操作人',
      paymentStatus: '收款状态',
      paymentStopped: '已停止收款',
      paymentOpen: '收款开放',
      realtime: '实时数据',
      detailBoundary: '首页仅提供门店日结汇总字段，不提供订单、渠道、支付或班次明细，也不提供门店现金和退款金额明细。',
      method: { MANUAL: '手动日结', AUTOMATIC: '自动日结' },
      cashStatus: {
        UNCHECKED: '部分收银机未盘点',
        BALANCED: '核对一致',
        DIFFERENCE: '存在差异',
        DIFFERENCE_UNCHECKED: '现金有差异，部分收银机未盘点',
      },
      attention: { CASH_DIFFERENCE: '现金核对存在差异', PENDING_REFUND: '存在待处理退款' },
      status: { PENDING: '待日结', SETTLED: '已日结' },
      emptyStores: '没有符合当前筛选条件的门店，请调整筛选条件。',
      cutoffHint: '查询时间为本次查询时点；统计截止时间不包含该时点，不等同于日结操作时间；营业日期保持原始日期。',
    },
    businessDate: '营业日期',
    conclusionTitle: '门店日结概况',
    conclusionSummary: '共 {total} 家门店，已完成日结 {settled} 家，待日结 {pending} 家。',
    previousDay: '前一天',
    nextDay: '后一天',
    metrics: '日结指标',
    settlementProgress: '日结进度',
    settlementProgressHint: '完成率 {percentage}%，还有 {pending} 家待处理',
    snapshotNetIncome: '日结净收入',
    snapshotNetIncomeHint: '已完成 {count} 家门店的日结快照',
    pendingEstimatedIncome: '待日结预估收入',
    pendingEstimatedIncomeHint: '来自 {count} 家待日结门店',
    attentionStores: '需关注门店',
    storesUnit: '家',
    attentionStoresHint: '存在现金差异或待处理退款',
    pendingRefundAmount: '待处理退款金额',
    pendingRefundAmountHint: '共 {count} 笔退款待处理',
    attentionTitle: '需关注门店',
    attentionSubtitle: '以下门店存在日结或资金核对事项',
    noAttentionStores: '暂无需关注门店',
    storeOverview: '门店日结列表',
    storeOverviewSubtitle: '当前筛选到 {total} 家门店',
    statusFilter: '日结状态筛选',
    notSettled: '未日结',
    noAttention: '无异常',
    viewDetails: '查看详情',
    storeSettlementDetails: '门店日结详情',
    readOnlySnapshot: '只读快照',
    snapshotAndEstimate: '日结快照与实时预估',
    snapshotAt: '快照时间：{time}',
    notAvailable: '暂无数据',
    realtimeEstimate: '实时预估收入',
    snapshotEstimateNote: '日结快照为完成日结时保存的数据；实时预估会随订单变化。',
    amountSummary: '金额汇总',
    grossIncome: '营业总额',
    discountAmount: '优惠金额',
    refundAmount: '退款金额',
    netIncome: '净收入',
    orderOverview: '订单概览',
    totalOrders: '订单总数',
    completedOrders: '完成订单',
    refundedOrders: '退款订单',
    cancelledOrders: '取消订单',
    channelSummary: '渠道汇总',
    channelDineIn: '堂食',
    channelTakeaway: '自提',
    channelDelivery: '外送',
    paymentWechat: '微信支付',
    paymentAlipay: '支付宝',
    paymentCash: '现金',
    paymentOther: '其他支付',
    refundAndCashCheck: '退款与现金核对',
    refundOverview: '退款概况',
    pendingRefunds: '待处理退款金额',
    refundCount: '退款笔数',
    refundStatus: '退款状态',
    refundStatusValue: { pending: '待处理', none: '无待处理退款' },
    cashReconciliation: '现金核对',
    expectedCash: '应收现金',
    actualCash: '实收现金',
    cashDifference: '现金差异',
    reconciliationResult: '核对结果',
    reconciliation: { matched: '一致', difference: '存在差异' },
    shiftInformation: '班次信息',
    shiftCount: '{count} 个班次',
    shiftMorning: '早班',
    shiftEvening: '晚班',
    mockCashierA: '张敏',
    mockCashierB: '李伟',
    shiftCashier: '收银员：{name}',
    shiftNetIncome: '班次净收入',
    searchKeyword: '门店名称',
    storeScope: '门店区域',
    scopeAll: '全部区域',
    scopeNorth: '华北区域',
    scopeEast: '华东区域',
    scopeSouth: '华南区域',
    scopeWest: '华西区域',
    settlementStatus: '日结状态',
    status: { all: '全部', settled: '已日结', pending: '待日结', attention: '需关注' },
    table: {
      storeName: '门店名称',
      scope: '所属区域',
      status: '日结状态',
      netAmount: '净收入',
      refundAmount: '退款金额',
      settlementTime: '日结时间',
      attention: '关注事项',
      action: '操作',
    },
    currencySymbol: '¥',
    attentionCashDifference: '现金核对存在差异',
    attentionRefundPending: '存在待处理退款',
    attentionNotSettled: '尚未完成日结',
    attentionLateSettlement: '日结时间较晚',
    mockStore01: '上海旗舰店',
    mockStore02: '上海浦东店',
    mockStore03: '上海徐汇店',
    mockStore04: '广州天河店',
    mockStore05: '广州番禺店',
    mockStore06: '深圳南山店',
    mockStore07: '北京朝阳店',
    mockStore08: '北京海淀店',
    mockStore09: '杭州西湖店',
    mockStore10: '杭州滨江店',
    mockStore11: '南京新街口店',
    mockStore12: '苏州中心店',
    mockStore13: '成都春熙路店',
    mockStore14: '重庆解放碑店',
    mockStore15: '武汉光谷店',
    mockStore16: '西安钟楼店',
    mockStore17: '天津和平店',
    mockStore18: '青岛市南店',
    mockStore19: '厦门思明店',
    mockStore20: '长沙五一广场店',
  },
};
